import styled, { css } from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import {
  spaceS,
  spaceM,
  xdlColorProJobs,
  xdlColorPremium,
  xdlColorHover,
  xdlColorText,
  xdlColorHoverSecondary,
  xdlColorProBusiness,
  cornerRadiusL,
  spaceXL,
  scale090,
  scale080,
} from '@xing-com/tokens';

type StyledLinkProps = {
  $color?: 'premium' | 'proJobs' | 'proBusiness';
  $isActive?: boolean;
};

export const StyledLink = styled(Link)<StyledLinkProps>`
  border-radius: ${cornerRadiusL};
  box-sizing: border-box;
  color: ${xdlColorText};
  font-size: ${scale080};
  display: flex;
  padding: ${spaceM} 0 ${spaceM} ${spaceS};
  width: auto;
  align-items: center;

  ${({ $isActive }) =>
    $isActive
      ? css`
          font-weight: bold;
        `
      : css``}

  &:hover {
    background-color: ${xdlColorHover};
    text-decoration: none;
  }
  &:active {
    background-color: ${xdlColorHoverSecondary};
  }

  ${({ $color }) => css`
    color: ${$color === 'premium'
      ? xdlColorPremium
      : $color === 'proJobs'
        ? xdlColorProJobs
        : $color === 'proBusiness' && xdlColorProBusiness};
  `};

  @media ${mediaTopBarVisible} {
    line-height: ${spaceXL};
    font-size: ${scale090};

    padding: ${spaceM} 0 ${spaceM} 0;
  }
`;
